export default {"src":"/_next/static/media/logo-mini.f66c1d87.svg","height":20,"width":56};